import { render } from "./selectProductClass.vue?vue&type=template&id=4c035792&scoped=true"
import script from "./selectProductClass.vue?vue&type=script&lang=js"
export * from "./selectProductClass.vue?vue&type=script&lang=js"

import "./selectProductClass.vue?vue&type=style&index=0&id=4c035792&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c035792"]])

export default __exports__